module.exports = __webpack_public_path__ + "img/13.4.NH3-N.7d395a58.png";